import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

/**
 * GoogleSignInButton, calm, brand-aligned Google OAuth trigger.
 * Uses Supabase's OAuth flow under the hood.
 */
export default function GoogleSignInButton({ label = 'Continue with Google', testId = 'auth-google-button' }) {
  const { signInWithGoogle } = useAuth();
  const [busy, setBusy] = useState(false);
  const click = async () => {
    setBusy(true);
    try {
      await signInWithGoogle();
      // Browser will redirect, no further work here.
    } catch (e) {
      setBusy(false);
      toast.error(e.message || 'Could not start Google sign-in.');
    }
  };
  return (
    <Button
      type="button"
      variant="outline"
      onClick={click}
      disabled={busy}
      className="w-full rounded-xl border-border/70 hover:bg-accent/40 gap-2"
      data-testid={testId}
    >
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.99 10.99 0 0 0 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.1A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.44.34-2.1V7.07H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.83z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.07.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.83C6.71 7.3 9.14 5.38 12 5.38z"/>
      </svg>
      <span>{busy ? 'Redirecting…' : label}</span>
    </Button>
  );
}
